import { vBColorMode } from "./src/directives/BColorMode/index.mjs";
import { vBToggle } from "./src/directives/BToggle/index.mjs";
import { vBPopover } from "./src/directives/BPopover/index.mjs";
import { vBScrollspy } from "./src/directives/BScrollspy/index.mjs";
import { vBTooltip } from "./src/directives/BTooltip/index.mjs";
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  vBColorMode,
  vBModal: vBToggle,
  vBPopover,
  vBScrollspy,
  vBToggle,
  vBTooltip
}, Symbol.toStringTag, { value: "Module" }));
export {
  index as i
};
//# sourceMappingURL=index-CXpBEYSc.mjs.map
